<script>
    import { Tooltip } from 'sveltestrap';
    import Spinner from 'svelte-spinner';

    import { formatDate, getApiDateFormat, isToday, getIsoDateStringAsDate } from '../../date-time.js';
    import { vptServer, token, reportDate, selectedAspect, inmateCount } from '../../stores.js';
    import { config } from "../../config";
    import { createRequestParams } from "../../string.js";

    export let requestProperties;

    let overviewData;
    
    let reportDateDescription;
    $: { if ($reportDate != undefined) { 
            reportDateDescription = formatDate(getApiDateFormat($reportDate));
        }
    }

    $: { if ($config.earlyRiskChecklistUrn && requestProperties && requestProperties.requestDate) {    
            overviewData = null;
            getEarlyRiskOverview(requestProperties.requestDate + createRequestParams(requestProperties.requestParams));
        }
    }

    async function getEarlyRiskOverview(requestString) {
        await fetch(`${$vptServer}/establishment/earlyrisk/overview/${requestString}`, {
            headers: {
                "Authorization": "Bearer " + $token
            }
        })
            .then(r => {
                if (!r.ok) {
                    throw Error(r.status);
                }
                return r;
            })
            .then(r => r.json())
            .then(data => {
                overviewData = data;
            })
            .catch(error => {
                console.error("Error getting establishment early risk overview");
                console.error(error);
                return;
            });
    }
</script>

<style>
    .establishment-widget {
        width: 120px;
    }

    .establishment-widget .no-records {
	    padding: 10px 10px 0 10px;
    }
</style>

{#if $config.earlyRiskChecklistUrn}
    <div class="establishment-widget">
        {#if overviewData && overviewData.countTotalInmates > 0 && !($inmateCount.filtered > $inmateCount.unfiltered)}
            <button on:click class="button-reset focus-outline card" class:selected={$selectedAspect === "Early Risk"}>
                <div class="card-body">
                    <div class="widget-container">
                        <span id="early-risk-overview-header" class="widget-label">Early Risk</span>
                        <Tooltip target="early-risk-overview-header" placement="bottom">{$config.earlyRiskFlagDescription}</Tooltip>
                        
                        <div class="widget-content">
                            <div class="count-widget">
                                <div class="count-widget-body">
                                    <div class="card-flex-column">        
                                        <div>
                                            <span class="targeted-count">{overviewData.countTargetedInmates}</span>
                                        </div>

                                        <div><span class="reduced-text">of</span></div>
                                        <div><span><b>{overviewData.countTotalInmates}</b> targeted</span></div>
                                    </div>
                                </div>

                                <div class="count-widget-footer">
                                    <span id="percentage-indicator-early-risk"
                                            class:percentage-indicator-up={overviewData.trendIndicatorTargetedInmates == 'U'}
                                            class:percentage-indicator-down={overviewData.trendIndicatorTargetedInmates == 'D'}>
                                        ({overviewData.percentageTargetedInmates})%
                                    </span>
                                    <Tooltip target="percentage-indicator-early-risk" placement="bottom">{overviewData.countTargetedInmates} of {overviewData.countTotalInmates} {$config.inmateLabelName.toLowerCase()}{overviewData.countTotalInmates == 1 ? '' : 's'} who arrived in the {isToday($reportDate) ? 'last' : 'previous'} {$config.earlyRiskNumberOfHoursPeriod} hours {isToday($reportDate) ? 'are' : 'were'} targeted with an {$config.earlyRiskFlagDescription}</Tooltip>
                                    {#if overviewData.trendIndicatorTargetedInmates == 'U'}
                                        <span id="trend-indicator-early-risk-u">
                                            <img src="/assets/arrow/arrow-up-danger.svg" alt="Increasing Trend" />
                                        </span>
                                        <Tooltip target="trend-indicator-early-risk-u" placement="bottom">Increasing Trend - Over the {isToday($reportDate) ? 'last' : 'previous'} {$config.trendPastDaysToAnalyse} days an average of     {overviewData.trendPercentageTargetedInmates}% were targeted with an {$config.earlyRiskFlagDescription}
                                        </Tooltip>
                                    {:else if overviewData.trendIndicatorTargetedInmates == 'D'}
                                        <span id="trend-indicator-early-risk-d">
                                            <img src="/assets/arrow/arrow-down-success.svg" alt="Decreasing Trend" />
                                        </span>
                                        <Tooltip target="trend-indicator-early-risk-d" placement="bottom">Decreasing Trend - Over the {isToday($reportDate) ? 'last' : 'previous'} {$config.trendPastDaysToAnalyse} days an average of     {overviewData.trendPercentageTargetedInmates}% were targeted with an {$config.earlyRiskFlagDescription}
                                        </Tooltip>
                                    {/if}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </button>
        {:else if overviewData}
            <div class="card" class:selected={$selectedAspect === "Early Risk"}>
                <div class="card-body">
                    <div class="widget-container">
                        <span id="early-risk-overview-header-no-records" class="widget-label">Early Risk</span>
                        <Tooltip target="early-risk-overview-header-no-records" placement="bottom">{$config.earlyRiskFlagDescription}</Tooltip>
                    
                        <div class="widget-content">
                            {#if ($inmateCount.filtered > $inmateCount.unfiltered) || ($inmateCount.unfiltered == 0 && isToday(getIsoDateStringAsDate(requestProperties.requestDate)))}
                                <span class="no-records">Data is being regenerated.</span>
                            {:else}
                                <span class="no-records">No {$config.earlyRiskAssessmentLabelName} data is available.</span>
                            {/if}
                        </div>
                    </div>
                </div>
            </div>
        {:else}
            <div class="card" class:selected={$selectedAspect === "Early Risk"}>
                <div class="card-body">
                    <div class="widget-container">
                        <div class="widget-spinner">
                            <Spinner size="100" speed="750" color="#3d5980" thickness="3" gap="15" />
                        </div>
                    </div>
                </div>
            </div>
        {/if}
    </div>
{/if}